//Навзвание функции ни о чем, но она считает градиент, или как там это называется
const fromTo = (from, to, percents) => {
    const decFrom = parseInt(from, 16);
    const decTo = parseInt(to, 16);

    const diff = decTo - decFrom;

    let result = Math.floor(decFrom + (diff / 100) * percents).toString(16);
    if (result.length === 1) {
        result = "0" + result;
    }

    return result;
};

export const getGradientValue = (startColor, finishColor, percents) => {
    let newColor = "";
    for (let i = 0; i < 6; i = i + 2) {
        newColor += fromTo(
            startColor.slice(i, i + 2),
            finishColor.slice(i, i + 2),
            percents
        );
    }
    return newColor;
};
